import type { PortalLogin } from './types';

import { http } from '@/utils/http';

/**
 * 小程序根据code登录
 * @param params 微信登录参数，包含code
 * @returns Promise 包含登录结果，返回服务器定义的 PortalLogin 对象
 */
export function miniAppLogin(data: { code: string }): Promise<PortalLogin> {
  return http.request({
    url: '/portal/auth/miniAppLogin',
    method: 'post',
    data,
  });
}
/**
 * 公众号根据code登录，如果使用snsapi_base这里的code就相当于是获取的openid
 * @param params 微信登录参数，包含code
 * @returns Promise 包含登录结果，返回服务器定义的 PortalLogin 对象
 */
export function mpLogin(data: { mpCode: string }): Promise<PortalLogin[]> {
  return http.request({
    url: '/portal/auth/mpLogin',
    method: 'post',
    data,
  });
}

// 根据code初始化微信用户信息
export const initWXUserInfo = (data: { code: string }, token: string) => {
  return http.request({
    url: '/portal/auth/initWXUserInfo',
    method: 'post',
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

/**
 * 刷新登录凭证
 * @returns Promise 包含刷新后的登录凭证
 */
export function refreshToken(): Promise<void> {
  return http.request({
    url: '/portal/auth/refreshToken',
    method: 'post',
  });
}
/**
 * 退出登录
 */
export function logoutAuth(): Promise<void> {
  return http.request({
    url: '/portal/auth/logout',
    method: 'post',
  });
}
